export default {
  hero: {
    title: '全方位客户支持服务',
    subtitle: '从需求对接至持续优化，我们提供全生命周期的专业支持，确保您的业务稳定运行'
  },
  serviceProcess: {
    title: '服务流程',
    steps: {
      step1: {
        title: '需求对接',
        description: '深入了解您的业务需求，提供专业咨询'
      },
      step2: {
        title: '方案设计',
        description: '定制专属解决方案，满足业务需求'
      },
      step3: {
        title: '实施部署',
        description: '专业团队高效实施，确保无缝上线'
      },
      step4: {
        title: '运维支持',
        description: '7×24小时监控，快速响应问题'
      },
      step5: {
        title: '优化升级',
        description: '持续优化系统性能，提供升级建议'
      }
    }
  },
  helpCenter: {
    title: '帮助中心',
    categories: {
      title: '常见问题分类',
      service: '服务咨询',
      trouble: '故障申报',
      compliance: '合规查询',
      technical: '技术支持',
      account: '账户管理'
    },
    needMoreHelp: '需要更多帮助？',
    onlineSupport: '在线客服咨询',
    searchPlaceholder: '搜索帮助中心...',
    faq: {
      service: {
        title: '服务咨询',
        q1: {
          question: 'Global Data提供哪些类型的技术支持服务？',
          answer: {
            intro: 'Global Data提供全方位的技术支持服务，包括：',
            list: [
              '7×24小时系统监控与故障响应',
              '远程技术支持与问题诊断',
              '定期系统健康检查与性能优化',
              '安全漏洞评估与修复建议',
              '系统升级与迁移支持',
              '定制化培训服务'
            ],
            conclusion: '我们根据客户需求提供不同级别的服务套餐，从基础支持到企业级专属服务团队。'
          }
        },
        q2: {
          question: '如何申请新的服务或升级现有服务？',
          answer: {
            intro: '申请新服务或升级现有服务可通过以下方式：',
            list: [
              '登录客户管理平台，在"服务管理"页面提交申请',
              '发送邮件至 {serviceEmail}，说明您的需求',
              '拨打客户服务热线400-123-4567',
              '通过在线客服系统实时咨询'
            ],
            conclusion: '我们的服务团队将在1个工作日内与您联系，讨论具体需求和实施方案。'
          }
        },
        q3: {
          question: '服务合同的有效期是多久？如何续约？',
          answer: {
            intro: '标准服务合同有效期为1年。我们会在合同到期前30天向您发送续约提醒。续约流程简单便捷：',
            list: [
              '登录客户管理平台查看续约选项',
              '确认服务内容和价格',
              '在线签署电子合同',
              '完成付款'
            ],
            conclusion: '长期合作客户可享受优惠价格和额外服务赠送。'
          }
        }
      },
      trouble: {
        title: '故障申报',
        content: '故障申报相关的常见问题内容将在这里显示...'
      },
      compliance: {
        title: '合规查询',
        content: '合规查询相关的常见问题内容将在这里显示...'
      },
      technical: {
        title: '技术支持',
        content: '技术支持相关的常见问题内容将在这里显示...'
      },
      account: {
        title: '账户管理',
        content: '账户管理相关的常见问题内容将在这里显示...'
      }
    },
    instantHelp: {
      title: '需要即时帮助？',
      subtitle: '我们的技术支持团队随时准备为您提供帮助',
      hotline: '服务热线',
      hotlineValue: '400-123-4567',
      email: '电子邮箱',
      emailLocalPart: 'support',
      serviceTime: '服务时间',
      serviceTime24x7: '7×24小时',
      contactSupport: '立即联系技术支持'
    }
  },
  sla: {
    title: '服务级别协议（SLA）',
    description: '我们承诺为不同需求的客户提供相应级别的服务保障，以下是我们的服务级别协议概述。详细SLA文档可联系客户经理获取。',
    table: {
      serviceItem: '服务项目',
      enterprise: '企业级',
      professional: '专业级',
      standard: '标准级',
      responseTime: '响应时间',
      criticalResolution: '解决时效（严重故障）',
      generalResolution: '解决时效（一般故障）',
      availability: '系统可用性',
      supportMethod: '技术支持方式',
      supportMethod_enterprise: '电话+远程+现场',
      supportMethod_professional: '电话+远程',
      supportMethod_standard: '远程支持',
      accountManager: '专属客户经理',
      compensation: '赔偿标准（服务中断）',
      compensation_enterprise: '服务时长×50倍',
      compensation_professional: '服务时长×30倍',
      compensation_standard: '服务时长×10倍',
      values: {
        responseTime: { enterprise: '15分钟', professional: '1小时', standard: '4小时' },
        criticalResolution: { enterprise: '2小时', professional: '8小时', standard: '24小时' },
        generalResolution: { enterprise: '8小时', professional: '24小时', standard: '48小时' },
        availability: { enterprise: '99.99%', professional: '99.9%', standard: '99.5%' }
      }
    },
    levels: {
      enterprise: {
        title: '企业级服务',
        description: '为关键业务系统提供最高级别的保障，适合对系统稳定性有极高要求的大型企业。',
        features: [
          '7×24小时专属支持团队',
          '15分钟快速响应',
          '现场支持服务',
          '季度系统健康检查'
        ],
        learnMore: '了解更多'
      },
      professional: {
        title: '专业级服务',
        description: '为重要业务系统提供全面保障，适合中大型企业的核心业务系统。',
        features: [
          '工作日8×12小时支持',
          '1小时内响应',
          '远程优先支持',
          '半年系统健康检查'
        ],
        learnMore: '了解更多'
      },
      standard: {
        title: '标准级服务',
        description: '为一般业务系统提供基础保障，适合小型企业或非核心业务系统。',
        features: [
          '工作日8小时支持',
          '4小时内响应',
          '远程支持服务',
          '年度系统健康检查'
        ],
        learnMore: '了解更多'
      }
    }
  },
  feedback: {
    title: '售后反馈与投诉',
    subtitle: '服务评价功能已下线。如需反馈问题、提出建议或发起投诉，请通过以下渠道联系我们，我们会尽快跟进处理。',
    evaluation: {
      title: '服务评价',
      subtitle: '您的反馈对我们非常重要，帮助我们不断提升服务质量',
      serviceType: '服务类型',
      serviceTypePlaceholder: '请选择服务类型',
      serviceTypes: {
        technical: '技术支持',
        consulting: '咨询服务',
        implementation: '实施部署',
        training: '培训服务',
        other: '其他服务'
      },
      satisfaction: '总体满意度',
      detailedFeedback: '详细评价',
      feedbackPlaceholder: '请分享您对我们服务的体验和建议...',
      acceptNotification: '我同意接收后续服务改进的相关通知',
      submit: '提交评价',
      successMessage: '感谢您的评价！我们会认真听取您的反馈。'
    },
    complaint: {
      title: '反馈与投诉渠道',
      subtitle: '如您在交付、运维、响应或沟通等环节需要反馈或升级处理，可通过以下方式提交，我们将在工作时间内尽快响应。',
      hotline: {
        title: '投诉热线',
        phone: '400-123-4567 转 8',
        time: '服务时间：工作日 9:00-18:00'
      },
      email: {
        title: '投诉邮箱',
        localPart: 'complaint',
        response: '我们将在24小时内回复您的邮件'
      },
      online: {
        title: '在线投诉',
        description: '登录客户管理平台提交投诉表单',
        tracking: '投诉处理进度可实时查询'
      },
      process: {
        title: '投诉处理流程',
        steps: [
          '提交反馈或投诉信息',
          '客服确认接收（24小时内）',
          '相关部门调查处理',
          '给出解决方案或处理意见',
          '客户确认处理结果'
        ]
      }
    }
  },
  cta: {
    title: '需要更多帮助？',
    subtitle: '我们的客户支持团队随时准备为您提供专业服务，解决您遇到的任何问题',
    contactSupport: '联系客户支持',
    viewDocumentation: '查看帮助文档'
  },
  chat: {
    title: '在线客服',
    placeholder: '输入您的问题...',
    welcome: '您好！我是智能客服助手，有什么可以帮助您的吗？',
    assistant: '客服助手',
    me: '我',
    justNow: '刚刚',
    autoReply: '感谢您的咨询，我们的客服人员将很快回复您。'
  }
}
